import React, { useCallback, useContext } from 'react';
import Button from '@material-ui/core/Button';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import { Theme } from '@material-ui/core/styles';

import { ArchivalUnitCopy } from 'types';
import { GridActionButtonComponent } from 'components/grid/grid-types';
import { NotificationVariant } from 'components/notification/notification-types';
import { NotificationCtx } from 'components/notification/notification-hook';
import { OrderCtx } from 'components/order-ctx/order-ctx';
import { AuthCtx } from '../../../components/auth/auth-ctx';
import { useEadTreeContext } from 'components/grid/grid-ctx/EadTreeCtx';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    navigationButton: {
      marginTop: theme.spacing(),
      alignSelf: 'baseline',
      width: '100%',
    },
  })
);

export function ArchivalUnitAddToCart({ item }: GridActionButtonComponent) {
  const archivalUnit = item as ArchivalUnitCopy;
  const classes = useStyles();
  const { userInfo } = useContext(AuthCtx);
  const { showNotification } = useContext(NotificationCtx);
  const { handleAddUnit, isArchivalUnitInOrder } = useContext(OrderCtx);
  const { crumbs } = useEadTreeContext();

  const isItemInOrderCtx = isArchivalUnitInOrder?.(archivalUnit?.numericId);

  const isForOrder =
    archivalUnit?.archivalUnitReference?.entityCharacter !== 'DIGITAL';

  const addItemToCart = useCallback(() => {
    handleAddUnit?.(
      archivalUnit.archivalUnitReference,
      crumbs?.[(crumbs?.length ?? 1) - 1].to ?? ''
    );
    showNotification(
      'Archiválie byla přidána do košíku.',
      NotificationVariant.INFO,
      3000
    );
  }, [archivalUnit, handleAddUnit, showNotification, crumbs]);

  return isForOrder && userInfo?.aisAuthenticated ? (
    <Button
      component="span"
      variant="outlined"
      color="primary"
      startIcon={isItemInOrderCtx ? undefined : <AddShoppingCartIcon />}
      className={classes.navigationButton}
      disabled={isItemInOrderCtx}
      onClick={addItemToCart}
    >
      {isItemInOrderCtx ? 'V košíku' : 'Přidej do objednávky'}
    </Button>
  ) : (
    <></>
  );
}
